import { ActivatedRoute, Router } from '@angular/router'
import { CoreService } from '../../services'
import { TranslateService } from '@ngx-translate/core'
import { ScrollService } from '../../services/scroll.service'

export abstract class BaseDetail {
  protected constructor(
    public route: ActivatedRoute,
    public router: Router,
    public core: CoreService,
    public translateService: TranslateService,
    public readonly scrollService: ScrollService,
  ) {}

  saveViewSettings(viewName: string, data: any): void {
    this.core.services.storage.set(this.core.services.storage.keys.views[viewName], data)
  }

  loadViewSettings(viewName: string): any {
    return this.core.services.storage.getSync(this.core.services.storage.keys.views[viewName])
  }

  onLoadError(errorCode: number) {
    switch (errorCode) {
      case 404:
      default:
        alert(this.translateService.instant('base-detail.not-found'))
        return this.router.navigate([`/${this.route.snapshot.url[0].path}s`])
      case 403:
        if (confirm(this.translateService.instant('base-detail.insufficient-permissions'))) {
          window['lastRoute'] = [`/${this.route.snapshot.url[0].path}`, this.route.snapshot.params['id']]
          this.core.services.oauth.logout()
        } else {
          return this.router.navigate([`/${this.route.snapshot.url[0].path}s`])
        }
    }
  }
}
